// extracted by mini-css-extract-plugin
module.exports = {"enemy":"Enemy_enemy__1IZxE","hp-bar":"Enemy_hp-bar__AL7sw","jump":"Enemy_jump__46z2-"};